import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddWaterMassUsageForecastMutation,
  useGetWaterMassUsageForecastByCommunityIdPaginationQuery,
} from "state/hp/hpApiSlice";

function ManageWaterMassUsageForecast({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.water_mass_usage_forecast.title")}
      subtitle={t("pages.water_mass_usage_forecast.subtitle")}
      taskType="WATER_MASS_USAGE_FORECAST"
      templateHref="/docs/template_hp_water_mass_usage_forecast.csv"
      addMutation={useAddWaterMassUsageForecastMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetWaterMassUsageForecastByCommunityIdPaginationQuery,
        resourceField: "hp_id",
        resourceLabel: t("pages.water_mass_usage_forecast.table.columns.hp"),
        resourceType: "HP",
        valueLabel: {
          field: "mass_value",
          label: t("pages.water_mass_usage_forecast.table.columns.mass_value"),
        },
        valueDigits: 4,
      }}
    />
  );
}

ManageWaterMassUsageForecast.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageWaterMassUsageForecast.defaultProps = {
  noWrapper: false,
};

export default ManageWaterMassUsageForecast;
